"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_OF_BIRTH_FORMAT = void 0;
exports.parseDateOfBirth = parseDateOfBirth;
exports.formatDateOfBirth = formatDateOfBirth;
exports.parseDateOfBirthToDate = parseDateOfBirthToDate;
exports.isValidDate = isValidDate;
exports.isValidAge = isValidAge;
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
exports.DATE_OF_BIRTH_FORMAT = 'MM-DD-YYYY';
const DATE_OF_BIRTH_PATTERN = /^\d{2}-\d{2}-\d{4}$/;
function parseDateOfBirth(dateOfBirth) {
  if (typeof dateOfBirth !== 'string' || !DATE_OF_BIRTH_PATTERN.test(dateOfBirth)) {
    return null;
  }
  const parsed = dayjs_1.default.utc(dateOfBirth, exports.DATE_OF_BIRTH_FORMAT, true);
  if (!parsed.isValid() || parsed.format(exports.DATE_OF_BIRTH_FORMAT) !== dateOfBirth) {
    return null;
  }
  return parsed;
}
function formatDateOfBirth(date) {
  return dayjs_1.default.utc(date).format(exports.DATE_OF_BIRTH_FORMAT);
}
function parseDateOfBirthToDate(dateOfBirth) {
  const parsed = parseDateOfBirth(dateOfBirth);
  if (!parsed) {
    throw new Error('Invalid date of birth');
  }
  return parsed.toDate();
}
/**
 * Validates that a string is a valid date of birth in MM-DD-YYYY format.
 */
function isValidDate(dateOfBirth) {
  return parseDateOfBirth(dateOfBirth) !== null;
}
/**
 * Validates age is between 18 and 100 for a date of birth in MM-DD-YYYY format.
 */
function isValidAge(dateOfBirth) {
  const parsed = parseDateOfBirth(dateOfBirth);
  if (!parsed) {
    return false;
  }
  const age = dayjs_1.default.utc().diff(parsed, 'year');
  return age >= 18 && age <= 100;
}
//# sourceMappingURL=date-of-birth.validator.js.map